const list = []

const handle = (e) => {
    list.forEach(item => {
        const popover = item._this.$refs[item.refs]
        if ( popover && !item.el.contains(e.target) && !popover.contains(e.target)) {
            item._this.close()
        }
    })
    
}

document.addEventListener('click', handle)

export default {
    'click-outside': {
        bind: (el, binding) => {
            list.push({
                el,
                refs:binding.arg,
                _this:binding.value.all
            })
        }
    }
}

const removeHandle = () => {
    document.removeEventListener('click', handle)
}

export { removeHandle }